import type { UseFormReturnType } from "@mantine/form"

import {
  SelectListRegistrationIdField,
  type RegistrationIdItem,
} from "~/components/SelectListRegistrationIdField"
import { FormFieldConfig } from "~/pages/Admin/components/form.types"
import { getNestedValue } from "~/utils/types"

const SelectListRegistrationId = (
  fields: FormFieldConfig,
  form: UseFormReturnType<Record<string, unknown>>
) => {
  const value =
    (getNestedValue(form.values, fields.name) as
      | { id?: string; registrationId: string; type: string }[]
      | undefined) ?? []

  const handleChange = (list: RegistrationIdItem[]): void => {
    form.setFieldValue(
      fields.name,
      list.map((item) => ({
        id: item.id,
        registrationId: item.registrationId,
        type: item.type,
      }))
    )
  }

  return (
    <SelectListRegistrationIdField
      value={value}
      onChange={handleChange}
      options={
        fields.options?.map((data) => ({
          label: data.label,
          value: data.value,
          description: data.description,
        })) ?? []
      }
      label={fields.label}
      tooltip={fields.tooltip}
      isRequired={fields.required ?? false}
      placeholder={fields.placeholder}
      disabled={fields.disabled}
      showLabelOnlyWhenNoTooltip
      labelProps={{ fz: "xs", fw: 600 }}
      classNames={fields.customClass}
    />
  )
}

export default SelectListRegistrationId
